import React from "react";
import { Tooltip } from "@mui/material";
import { colors } from "../utils/colors";

const TooltipBox = ({ title, children, arrow = true, ...props }) => {
  return (
    <Tooltip
      title={title}
      arrow
      {...props}
      disableInteractive
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "10px",
            fontFamily: "Roboto",
            fontWeight: "400",
            color:"#14285A",
            bgcolor: "#FFFF",
            boxShadow: '0px 0px 3px #0000001A',
            "& .MuiTooltip-arrow": {
              color: "#FFFF",
              width: "0.5em !important",
              height: "0.8em !important",
              marginLeft: "-0.5em !important",
              boxShadow: '0px 0px 3px #0000001A',
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipBox;
